<template>
  <div v-if="initializing" class="text-center mb-2">
    <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-4"/>
  </div>

  <div v-else>
    <b-btn
      variant="outline-success"
      class="mb-4"
      size="sm"
      @click="addTransportLicense(transport)"
    >
      {{ $t('transports.addTransportLicense') }}
    </b-btn>

    <template v-if="licenses && licenses.length">
      <b-card
        v-for="(license, index) in licenses"
        :key="license.id"
        body-class="pb-0"
        class="license-item-border border-primary"
        :class="{ 'mb-0': licenses.length - 1 === index }"
      >
        <b-row class="align-items-center">
          <b-col md="4">
            <div class="mb-2 text-muted">
              {{ $t('transports.driverInfo') }} :
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('account.firstName') }} :
              </span>

              {{ license.driverFirstName }}
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('account.lastName') }} :
              </span>

              {{ license.driverLastName }}
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('account.nationalCode') }} :
              </span>

              {{ license.driverNationalCode }}
            </div>
          </b-col>

          <b-col md="3">
            <div class="mb-2 text-muted">
              {{ $t('transports.carInfo') }} :
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('shared.name') }} :
              </span>

              {{ license.vehicleName }}
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('transports.trailerName') }} :
              </span>

              {{ license.trailerName }}
            </div>

            <div class="mb-3">
              <span class="text-muted">
                {{ $t('transports.disciplinaryNumber') }} :
              </span>

              {{ license.plateCode }} - {{ license.plateNumber }}
            </div>
          </b-col>

          <b-col md="3">
            <div class="mb-2 text-muted">
              {{ $t('transports.licenseValidity') }} :
            </div>

            <div class="mb-3">
              {{ $t('transports.fromDate') }}
              <date-display :value="license.validFrom" icon-class=""/>

              {{ $t('transports.toDate') }}
              <date-display :value="license.validUntil" icon-class=""/>
            </div>
          </b-col>

          <b-col class="mb-3 mb-md-0">
            <b-btn
              variant="outline-secondary"
              class="text-dark mb-2"
              block
              size="sm"
              target="_blank"
              :to="`/transports/${transport.id}/licenses/${license.id}`"
            >
              {{ $t('transports.transportLicense') }}
            </b-btn>

            <b-btn
              variant="outline-secondary"
              class="text-dark mb-2"
              block
              size="sm"
              target="_blank"
              :to="`/transports/${transport.id}/licenses/${license.id}/license-record`"
            >
              {{ $t('transports.licenseRecord') }}
            </b-btn>

            <template v-if="!transport.status">
              <b-btn
                variant="outline-info"
                class="text-dark"
                block
                size="sm"
                @click="editTransportLicense(transport, license.id)"
              >
                {{ $t('shared.edit') }}
              </b-btn>
            </template>
            
            <b-btn
              v-else-if="license.transportRecord"
              variant="outline-warning"
              class="text-dark"
              block
              size="sm"
              target="_blank"
              :to="`/transports/${transport.id}/licenses/${license.id}/license-record`"
            >
              {{ $t('transports.transportRecord') }}
            </b-btn>
          </b-col>
        </b-row>
      </b-card>
    </template>

    <div v-else class="text-center text-muted mb-2">
      {{ $t('shared.noRecords') }}
    </div>

    <add-transport-license ref="addTransportLicense" @refresh="refresh"/>
    <edit-transport-license ref="editTransportLicense" @refresh="refresh"/>
  </div>
</template>

<script>
import AddTransportLicense from './Create'
import EditTransportLicense from './Edit'
import { DateDisplay } from '@/components/shared'

export default {
  name: 'TransportLicenses',
  components: {
    AddTransportLicense,
    EditTransportLicense,
    DateDisplay
  },
  props: {
    transport: Object,
    transportIndex: Number
  },
  data () {
    return {
      initializing: true,
      licenses: null
    }
  },
  mounted () {
    this.getModel()
    .then(() => {
      this.initializing = false
    })
  },
  methods: {
    getModel () {
      return this.$api.transports.getAllLicenses(this.transport.id)
      .then(res => {
        this.licenses = res
      })
      .catch(err => {
        this.$showError(this.$getLocaleErrorMessage(err, 'transports'))
        this.initializing = false
      })
    },
    addTransportLicense (transport) {
      this.$refs.addTransportLicense.show(transport)
    },
    editTransportLicense (transport, licenseId) {
      this.$refs.editTransportLicense.show(transport, licenseId)
    },
    refresh () {
      this.initializing = true
      this.getModel()
      .then(() => {
        this.initializing = false
      })
    }
  }
}
</script>
